import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusCharging = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
			fill: "#9BCBFE"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_61_2014)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 10C1.66675 8.84723 1.8855 7.76389 2.323 6.75001C2.7605 5.73612 3.35425 4.85417 4.10425 4.10417C4.85425 3.35417 5.73619 2.76042 6.75008 2.32292C7.76397 1.88542 8.8473 1.66667 10.0001 1.66667C11.1529 1.66667 12.2362 1.88542 13.2501 2.32292C14.264 2.76042 15.1459 3.35417 15.8959 4.10417C16.6459 4.85417 17.2397 5.73612 17.6772 6.75001C18.1147 7.76389 18.3334 8.84723 18.3334 10C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333ZM9.50008 11.25V14.1042C9.50008 14.3264 9.60425 14.4618 9.81258 14.5104C10.0209 14.559 10.1806 14.4861 10.2917 14.2917L12.8126 9.35417C12.882 9.21528 12.8751 9.07987 12.7917 8.94792C12.7084 8.81598 12.5904 8.75001 12.4376 8.75001H10.6251V5.85417C10.6251 5.63195 10.5209 5.49306 10.3126 5.43751C10.1042 5.38195 9.94453 5.45139 9.83342 5.64584L7.20842 10.6458C7.13897 10.7986 7.14244 10.9375 7.21883 11.0625C7.29522 11.1875 7.4098 11.25 7.56258 11.25H9.50008Z",
				fill: "#115996"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_61_2014",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
export default SvgStatusCharging;
